import { Col, Row, Space, Typography } from "antd";
import React from "react";

const VisualAcuityPrint = ({ detail, type = 1 }) => {
  const value = [
    {
      key: 1,
      side: "right",
      name1: "Thị lực không kính: ",
      name2: "Thị lực không kính(gần): ",
      name3: "PR(Thị lực không kính): ",
      name4: "Thị lực kính lỗ: ",
      name5: "Thị lực kính gọng: ",
      name6: "Thị lực kính gọng(gần): ",
      name7: "Kính tiếp xúc: ",
      title: "Đo thị lực: ",
      name8: "Thị lực: ",
      name9: "Thị lực(kính lỗ): ",
    },
    {
      key: 2,
      side: "left",
      name1: "Thị lực không kính: ",
      name2: "Thị lực không kính(gần): ",
      name3: "PR(Thị lực không kính): ",
      name4: "Thị lực kính lỗ: ",
      name5: "Thị lực kính gọng: ",
      name6: "Thị lực kính gọng(gần): ",
      name7: "Kính tiếp xúc: ",
      title: "Đo thị lực:",
      name8: "Thị lực: ",
      name9: "Thị lực(kính lỗ): ",
      // name1: "",
      // name2: "",
      // name3: "",
      // name4: "",
      // name5: "",
      // name6: "",
      // name7: "",
      // name8: "",
      // name9: "",
    },
  ];
  return (
    <div
      className="visual-acuity"
      style={{ width: "100%"}}
    >
      <Row gutter={8}>
        {value.map((item) => {
          return detail?.visualAcuityDtos ? (
            <Col span={12} key={item.key}>
              <Row
                style={{
                  width: "100%",
                  fontWeight: "bold",
                }}
              >
                {/* <Typography.Text style={{ fontWeight: "bold" }}> */}
                {item.title}
                {/* </Typography.Text> */}
              </Row>

              <Row className="content-visual">
                <Space direction="vertical" style={{ gap: 0 }}>
                  {detail?.visualAcuityDtos[item.side]?.ucva1 && (
                    <Typography.Text
                      className="title-print-child"
                      // style={{ fontSize: type === 1 ? "14px" : "" }}
                    >
                      {item.name1}
                      {detail?.visualAcuityDtos[item.side]?.ucva1}
                      {detail?.visualAcuityDtos[item.side]?.ucvaP1 && `(P) `}
                      {detail?.visualAcuityDtos[item.side]?.ucva1Value &&
                        `(${detail?.visualAcuityDtos[item.side]?.ucva1Value}) `}
                    </Typography.Text>
                  )}
                  {detail?.visualAcuityDtos[item.side]?.ucva2 && (
                    <Typography.Text
                      className="title-print-child"
                      // style={{ fontSize: type === 1 ? "14px" : "" }}
                    >
                      {item.name2}
                      {detail?.visualAcuityDtos[item.side]?.ucva2}
                      {detail?.visualAcuityDtos[item.side]?.ucvaP2 && `(P) `}
                      {detail?.visualAcuityDtos[item.side]?.ucva2Value &&
                        `(${detail?.visualAcuityDtos[item.side]?.ucva2Value}) `}
                    </Typography.Text>
                  )}
                  {/* sr */}
                  {detail?.visualAcuityDtos[item.side]?.prS && (
                    <Typography.Text
                      className="title-print-child"
                      // style={{ fontSize: type === 1 ? "14px" : "" }}
                    >
                      {item.name3}{" "}
                      {detail?.visualAcuityDtos[item.side]?.prS &&
                        ` S${detail?.visualAcuityDtos[item.side]?.prS}`}
                      {detail?.visualAcuityDtos[item.side]?.prI &&
                        ` I${detail?.visualAcuityDtos[item.side]?.prI}`}
                      {detail?.visualAcuityDtos[item.side]?.prN &&
                        ` N${detail?.visualAcuityDtos[item.side]?.prN}`}
                      {detail?.visualAcuityDtos[item.side]?.prT &&
                        ` T${detail?.visualAcuityDtos[item.side]?.prT} `}
                    </Typography.Text>
                  )}
                  {/* pinhole */}
                  {detail?.visualAcuityDtos[item.side]?.pinhole && (
                    <Typography.Text
                      className="title-print-child"
                      // style={{ fontSize: type === 1 ? "14px" : "" }}
                    >
                      {" "}
                      {item.name4}{" "}
                      {detail?.visualAcuityDtos[item.side]?.pinhole}
                      {detail?.visualAcuityDtos[item.side]?.pinholeP && ` (P)`}
                      {detail?.visualAcuityDtos[item.side]?.pinholeNI &&
                        `(NI) `}
                      {detail?.visualAcuityDtos[item.side]?.pinholeValue &&
                        `(${
                          detail?.visualAcuityDtos[item.side]?.pinholeValue
                        })`}{" "}
                    </Typography.Text>
                  )}
                  {/* glass1 */}
                  {detail?.visualAcuityDtos[item.side]?.glasses1 && (
                    <Typography.Text
                      className="title-print-child"
                      // style={{ fontSize: type === 1 ? "14px" : "" }}
                    >
                      {item.name5}{" "}
                      {detail?.visualAcuityDtos[item.side]?.glasses1}
                      {detail?.visualAcuityDtos[item.side]?.glassesP1 && `(P) `}
                      {detail?.visualAcuityDtos[item.side]?.glasses1Value &&
                        `(${
                          detail?.visualAcuityDtos[item.side]?.glasses1Value
                        })`}{" "}
                    </Typography.Text>
                  )}
                  {/* glasses 2 */}
                  {detail?.visualAcuityDtos[item.side]?.glasses2 && (
                    <Typography.Text
                      className="title-print-child"
                      // style={{ fontSize: type === 1 ? "14px" : "" }}
                    >
                      {item.name6}{" "}
                      {detail?.visualAcuityDtos[item.side]?.glasses2}
                      {detail?.visualAcuityDtos[item.side]?.glassesP2 && `(P) `}
                      {detail?.visualAcuityDtos[item.side]?.glasses2Value &&
                        `(${
                          detail?.visualAcuityDtos[item.side]?.glasses2Value
                        })`}{" "}
                    </Typography.Text>
                  )}
                  {/* contact lens */}
                  {detail?.visualAcuityDtos[item.side]?.contactLens && (
                    <Typography.Text
                      className="title-print-child"
                      // style={{ fontSize: type === 1 ? "14px" : "" }}
                    >
                      {item.name7}{" "}
                      {detail?.visualAcuityDtos[item.side]?.contactLens}
                      {detail?.visualAcuityDtos[item.side]?.contactP && `(P) `}
                      {detail?.visualAcuityDtos[item.side]?.contactLensValue &&
                        `(${
                          detail?.visualAcuityDtos[item.side]?.contactLensValue
                        })`}{" "}
                    </Typography.Text>
                  )}
                </Space>
              </Row>

              {/* ucav2 */}
              <Row>
                {detail?.visualAcuityDtos[item.side]?.comments && (
                  <Typography.Text
                    style={{
                      paddingTop: "10px",
                      // fontSize: type === 1 ? "14px" : "",
                    }}
                  >
                    <span className="title-print">Nhận xét: </span>
                    {detail?.visualAcuityDtos[item.side]?.comments}
                  </Typography.Text>
                )}
              </Row>
            </Col>
          ) : (
            <Col span={12} key={item.key}>
              <Row wrap style={{ width: "100%", height: "22px" }}>
                <Typography.Text style={{ fontWeight: "bold" }}>
                  {item.title}
                </Typography.Text>
              </Row>

              <Row>
                <Space direction="vertical" style={{ gap: "2px" }}>
                  {detail?.dryRefraction[item.side]?.tb1?.ucva && (
                    <Typography.Text
                      className="title-print-child"
                      // style={{ fontSize: type === 1 ? "14px" : "" }}
                    >
                      {item.name1}
                      {detail?.dryRefraction[item.side]?.tb1?.ucva[0]} -{" "}
                      {detail?.dryRefraction[item.side]?.tb1?.ucva[2]}
                    </Typography.Text>
                  )}

                  {detail?.dryRefraction[item.side]?.tb1?.vision && (
                    <Typography.Text
                      className="title-print-child"
                      // style={{ fontSize: type === 1 ? "14px" : "" }}
                    >
                      {item.name8}
                      {detail?.dryRefraction[item.side]?.tb1?.vision[0]} -{" "}
                      {detail?.dryRefraction[item.side]?.tb1?.vision[2]}
                    </Typography.Text>
                  )}
                  {detail?.dryRefraction[item.side]?.tb1?.va && (
                    <Typography.Text
                      className="title-print-child"
                      // style={{ fontSize: type === 1 ? "14px" : "" }}
                    >
                      {item.name9}
                      {detail?.dryRefraction[item.side]?.tb1?.va[0]} -{" "}
                      {detail?.dryRefraction[item.side]?.tb1?.va[2]}
                    </Typography.Text>
                  )}
                </Space>
              </Row>
            </Col>
          );
        })}
      </Row>
    </div>
  );
};

export default VisualAcuityPrint;
